import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import colors from '../../../../assets/theme/base/colors';

export type CellContent = 'headcount' | 'detailed';
export type DesignationFilter = 'all' | 'designated';

interface HeatMapToolbarProps {
    cellContent: CellContent;
    onCellContentChange: (val: CellContent) => void;
    designationFilter: DesignationFilter;
    onDesignationChange: (val: DesignationFilter) => void;
}

const toggleSx = {
    fontSize: '0.8125rem',
    fontWeight: 500,
    textTransform: 'none',
    px: 1.5,
    py: 0.5,
    lineHeight: 1.5,
    border: `1px solid ${colors.ui.border} !important`,
    color: colors.ui.secondaryText,
    '&.Mui-selected': {
        backgroundColor: colors.ui.activeBackground,
        color: colors.white.main,
        '&:hover': { backgroundColor: colors.ui.activeBackgroundHover },
    },
};

export function HeatMapToolbar({ cellContent, onCellContentChange, designationFilter, onDesignationChange }: HeatMapToolbarProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ fontSize: '0.75rem', color: colors.ui.secondaryText, whiteSpace: 'nowrap' }}>Cell content</Box>
                <ToggleButtonGroup
                    value={cellContent}
                    exclusive
                    onChange={(_, val) => val && onCellContentChange(val as CellContent)}
                    size="small"
                >
                    <ToggleButton value="headcount" sx={toggleSx}>Headcount</ToggleButton>
                    <ToggleButton value="detailed" sx={toggleSx}>Detailed</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ fontSize: '0.75rem', color: colors.ui.secondaryText, whiteSpace: 'nowrap' }}>Designation</Box>
                <ToggleButtonGroup
                    value={designationFilter}
                    exclusive
                    onChange={(_, val) => val && onDesignationChange(val as DesignationFilter)}
                    size="small"
                >
                    <ToggleButton value="all" sx={toggleSx}>All</ToggleButton>
                    <ToggleButton value="designated" sx={toggleSx}>Designated</ToggleButton>
                </ToggleButtonGroup>
            </Box>
        </Box>
    );
}
